var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`formulate-input-element--${_vm.context.type}--label`,domProps:{"textContent":_vm._s(_vm.context.value || _vm.context.label || _vm.context.name || 'Submit')}})
}
var staticRenderFns = []

export { render, staticRenderFns }